var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isActionButton
      ? _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: {
              type: "button",
              "data-bs-toggle": "modal",
              "data-oevent-category": _vm.actionTms.category,
              "data-oevent-action": _vm.actionTms.action,
              "data-oevent-label": _vm.actionTms.label,
              "data-bs-target": "#" + _vm.id,
            },
          },
          [_vm._v("\n        " + _vm._s(_vm.actionLabel) + "\n    ")]
        )
      : _c(
          "button",
          {
            staticClass: "ob1-link-arrow",
            attrs: {
              "data-bs-toggle": "modal",
              "data-oevent-category": _vm.actionTms.category,
              "data-oevent-action": _vm.actionTms.action,
              "data-oevent-label": _vm.actionTms.label,
              "data-bs-target": "#" + _vm.id,
            },
          },
          [_vm._v("\n        " + _vm._s(_vm.actionLabel) + "\n    ")]
        ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        class: _vm.imageUrl ? "ob1-modal-visual" : "",
        attrs: {
          id: _vm.id,
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": _vm.labelId,
          "aria-hidden": "true",
          "data-ob1-component": "Popin",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c(
              "div",
              { staticClass: "modal-content" },
              [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn-close",
                      attrs: {
                        type: "button",
                        "data-bs-dismiss": "modal",
                        "aria-label": _vm.modalCloseLabel,
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "icon icon-delete",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-close ob1-link-arrow back",
                      attrs: { type: "button", "data-bs-dismiss": "modal" },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.modalCloseLabel) +
                          "\n                    "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.imageUrl
                  ? _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "ob1-modal-body-visual" }, [
                        _c("div", { staticClass: "ob1-modal-img" }, [
                          _c("img", {
                            attrs: { src: _vm.imageUrl, alt: _vm.imageAlt },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ob1-modal-content" }, [
                          _vm.modalTitle
                            ? _c("h4", {
                                staticClass: "h3",
                                attrs: { id: _vm.labelId },
                                domProps: { innerHTML: _vm._s(_vm.modalTitle) },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.modalContent
                            ? _c("p", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.modalContent) +
                                    "\n                            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "ob1-modal-footer-visual" },
                            [
                              _vm.isModalButtonPrimary
                                ? _c(
                                    "button",
                                    _vm._b(
                                      {
                                        staticClass: "btn btn-primary m-0",
                                        attrs: { type: "button" },
                                      },
                                      "button",
                                      _vm.isModalButtonClose
                                        ? { "data-bs-dismiss": "modal" }
                                        : {},
                                      false
                                    ),
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(_vm.modalButtonLabel) +
                                          "\n                                "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "button",
                                    _vm._b(
                                      {
                                        staticClass: "btn btn-secondary m-0",
                                        attrs: { type: "button" },
                                      },
                                      "button",
                                      _vm.isModalButtonClose
                                        ? { "data-bs-dismiss": "modal" }
                                        : {},
                                      false
                                    ),
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(_vm.modalButtonLabel) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                            ]
                          ),
                        ]),
                      ]),
                    ])
                  : [
                      _c(
                        "div",
                        { staticClass: "modal-body" },
                        [
                          _vm.modalTitle
                            ? _c("h4", {
                                staticClass: "h3",
                                attrs: { id: _vm.labelId },
                                domProps: { innerHTML: _vm._s(_vm.modalTitle) },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.modalContent
                            ? _c("p", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.modalContent) +
                                    "\n                        "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("modalBody"),
                          _vm._v(" "),
                          _vm.alertHtmlContent
                            ? _c("div", {
                                staticClass:
                                  "alert-container additional-message",
                                domProps: {
                                  innerHTML: _vm._s(_vm.alertHtmlContent),
                                },
                              })
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "modal-footer d-inline-flex flex-column flex-md-row-reverse justify-content-center",
                        },
                        [
                          _vm.isModalButtonPrimary
                            ? _c(
                                "button",
                                _vm._b(
                                  {
                                    staticClass:
                                      "btn btn-primary mx-0 mb-2 ms-md-2 mb-md-0",
                                    attrs: { type: "button" },
                                  },
                                  "button",
                                  _vm.isModalButtonClose
                                    ? { "data-bs-dismiss": "modal" }
                                    : {},
                                  false
                                ),
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.modalButtonLabel) +
                                      "\n                        "
                                  ),
                                ]
                              )
                            : _c(
                                "button",
                                _vm._b(
                                  {
                                    staticClass: "btn btn-secondary m-0",
                                    attrs: { type: "button" },
                                  },
                                  "button",
                                  _vm.isModalButtonClose
                                    ? { "data-bs-dismiss": "modal" }
                                    : {},
                                  false
                                ),
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.modalButtonLabel) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                        ]
                      ),
                    ],
              ],
              2
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }